import ContentHeader from "@components/ContentHeader";
import Title from "@components/Title";
import LineTabs from "@components/LineTabs";
import { FCX } from "@datassential/platform-ui-lib";
import { useTrendContext } from "@pages/Trend/TrendContext";
import { SelectSingle } from "@components/Select";
import { useMetricOptions } from "@core/hooks/useMetricOptions";
import { TREND_METRICS_ORDER } from "@core/models/Metric";
import { TrendTab } from "@core/constants";
import SelectAmong from "@vms/SelectAmong";

const TREND_TABS = [
    { id: TrendTab.HistoricTrend, title: 'Historic Trend' },
    { id: TrendTab.TrendSummary, title: 'Trend Summary' },
]

const TrendHeader: FCX = () => {
    const {
        activeTab,
        setActiveTab,
        selectedMetric,
        setSelectedMetric,
    } = useTrendContext();

    const metricsOptions = useMetricOptions(TREND_METRICS_ORDER);

    return (
        <div className="TrendHeader">
            <ContentHeader>
                <Title testId="textTrendTitle">Trend</Title>
            </ContentHeader>
            <ContentHeader>
                <LineTabs
                    data={TREND_TABS}
                    activeTabId={activeTab}
                    onItemClick={setActiveTab}
                    testId="blockTrendTabs"
                />
                <div className="TrendHeader__filters">
                    {
                        metricsOptions.length > 1 && activeTab !== TrendTab.TrendSummary  && (
                            <SelectSingle
                                className="TrendHeader__select TrendHeaderSelect appears-right fast"
                                value={selectedMetric}
                                setValue={setSelectedMetric}
                                options={metricsOptions}
                                label="SHOW:"
                                testId="selectProfileTrendMetric"
                            />
                        )
                    }
                    <SelectAmong
                        className="TrendHeader__select TrendHeaderSelect"
                        label={<span data-testid="textProfileTrendRespondentType">AMONG:</span>}
                        testId="selectTrendAmong"
                        useGroupsLimit
                        useCoExclusions
                    />
                </div>
            </ContentHeader>
        </div>
    );
};

export default TrendHeader;